import { render } from "./Hero.vue?vue&type=template&id=c96509b8&scoped=true"
import script from "./Hero.vue?vue&type=script&setup=true&lang=js"
export * from "./Hero.vue?vue&type=script&setup=true&lang=js"

import "./Hero.vue?vue&type=style&index=0&id=c96509b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c96509b8"],['__file',"src/components/Paragraphs/Hero.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c96509b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c96509b8', __exports__)) {
    api.reload('c96509b8', __exports__)
  }
  
  module.hot.accept("./Hero.vue?vue&type=template&id=c96509b8&scoped=true", () => {
    api.rerender('c96509b8', render)
  })

}


export default __exports__